import { useDispatch } from 'react-redux';
import { setShowEmma } from '../../../features/askEmma/askEmmaSlice';
import { useAskEmma } from '../../../contexts/AskEmmaContext';

/**
 * Custom hook to handle Ask EMMA question functionality from report components
 * Provides a simple interface to send predefined questions to the Ask EMMA chat
 */
export const useAskEmmaQuestions = () => {
    const dispatch = useDispatch();
    const { sendMessage } = useAskEmma();

    /**
     * Sends a question to Ask EMMA chat
     * Opens the chat if it's not already open and sends the question
     * @param {string} question - The question text to send
     */
    const askEmmaQuestion = (question) => {
        if (!question || typeof question !== 'string') {
            console.error('Invalid question provided to askEmmaQuestion');
            return;
        }

        // Ensure Ask EMMA chat is visible
        dispatch(setShowEmma(true));

        // Small delay to ensure chat is rendered before sending message
        setTimeout(() => {
            sendMessage(question, '');
        }, 300);
    };

    return {
        askEmmaQuestion
    };
};
